<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <div class="d-flex flex-align-center flex-justify-between page-breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/message/messageCenter' }">消息中心</el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button size="small" class="mg-btm20 mg-rgt20" @click="$router.back()">返回</el-button>
        </div>
        <div class="main-table">
            <my-form :form-config="formItems" :formRules="{}" :dataForm="dataForm" :disableForm="true"></my-form>
        </div>
    </div>
</template>

<script>
import myForm from '@/components/myForm.vue';
import { messageDetails } from '@/api/message.js'
export default {
    components: {
        myForm,
    },
    data () {
        return {
            formItems: [
                { type: 'input', prop: 'title', label: '标题' },
                { type: 'input', prop: 'createTime', label: '发布时间' },
                { type: 'input', prop: 'content', label: '内容' },
                // Add more form items as needed
            ],

            dataForm: {
            },
            id: '',
        }
    },
    created () {
        this.id = this.$route.query.id;
        if (this.id) {
            this.getDetails();
        }

    },
    watch: {
        $route () {
            this.id = this.$route.query.id;
            if (this.id) {
                this.getDetails();
            }
        }
    },
    methods: {
        getDetails () {
            messageDetails(this.id).then(res => {
                this.dataForm = res.data
                this.$store.commit('getMessageIsReadNum')
            })
        }
    }

}
</script>

<style lang="scss" scoped>
.el-breadcrumb {
    padding-bottom: 10px;
}

.main-table {
    padding-top: 20px;
    border-top: 1px solid #eee;

}
.page-breadcrumb{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/message/messageDetails.vue